import '../../libs/polyfills/polyfills';
import PageSkinPin from '../../components/fsUtils/pageSkinPin';
import Ads from '../../components/ads/Ads';
import BannerPin from '../../components/ads/BannerAdsPin';
import skinAdsPin from '../../components/ads/skinAdsPin';
import analytics from '../../components/analytics/Analytics';
import ScoreStrip from '../../components/scorestrip/scorestrip';
import CountdownClock from '../../components/sidebar/CountdownClock';
import TopVideos from '../../components/sidebar/TopVideos.js';
import PromoBanner from '../../components/promo/promo';

var ads = new Ads();
ads.enableRenderOnScroll();
ads.renderPageAds();

// Set up sidebar components
var countdownClocks = document.querySelectorAll('.sidebar-component-countdown-clock');
if (countdownClocks.length > 0) {
    for (let i of countdownClocks) {
        new CountdownClock(i);
    }
}

new TopVideos();
//temporary for external access
//being used in big-board.js and marquee gallery
window.FsAds = ads;

analytics.sendPageView();

if (document.querySelector('wis-scorestrip')) {
    new ScoreStrip().init();
}

//object can be reused when importing this script
export default {
    'ads': ads,
    'analytics': analytics
}


// WEBPACK FOOTER //
// ./assets/layouts/base/base.js